/*Import Estilo*/
import '../institucional.scss';
import '../../../css/global.css';
import '../../../css/normalize.css';

/*Import Componentes*/
import Cabecalho from '../../../components/Cabecalho';
import Rodape from '../../../components/Rodape';
import CookieAceite from '../../../components/CookieAceite';

/*Import SEO*/
import { SEOHelmet } from '../../../hooks/useSEO';

export default function TermosDeUso() {
    const seoData = {
        title: 'Termos de Uso - Fracaro Store',
        description: 'Leia os termos e condições de uso da Fracaro Store. Regras gerais para a utilização do nosso site e serviços.',
        keywords: 'termos de uso, condições, regras, fracaro store',
        url: window.location.href,
    };

    return (
        <section className='container-principal-institucional'>
            <SEOHelmet {...seoData} />
            <Cabecalho />
            <CookieAceite />
            <main>
                <div className='hero-institucional'>
                    <div className='hero-overlay'>
                        <h1>Termos de Uso</h1>
                        <p>Regras gerais para utilização do nosso site</p>
                    </div>
                </div>

                <div className='conteudo-institucional'>
                    <h2>1. Aceitação dos Termos</h2>
                    <p>
                        Ao acessar e utilizar o site da <strong>Fracaro Store</strong>, você concorda com estes 
                        Termos de Uso. Caso não concorde com algum dos termos, pedimos que não utilize nosso site.
                    </p>

                    <h2>2. Cadastro e Conta</h2>
                    <p>Para realizar compras, é necessário criar uma conta em nosso site. Ao se cadastrar, você se compromete a:</p>
                    <ul>
                        <li>Fornecer informações verdadeiras, completas e atualizadas</li>
                        <li>Manter a confidencialidade da sua senha</li>
                        <li>Não compartilhar sua conta com terceiros</li>
                        <li>Notificar imediatamente sobre qualquer uso não autorizado</li>
                    </ul>

                    <div className='destaque-box'>
                        <p>Você é responsável por todas as atividades realizadas em sua conta. Mantenha sua senha segura e não a compartilhe.</p>
                    </div>

                    <h2>3. Produtos e Preços</h2>
                    <p>
                        Buscamos manter todas as informações dos produtos atualizadas e precisas. No entanto:
                    </p>
                    <ul>
                        <li>Os preços podem ser alterados sem aviso prévio</li>
                        <li>As cores dos produtos podem variar conforme o monitor/dispositivo</li>
                        <li>A disponibilidade dos produtos está sujeita ao estoque</li>
                        <li>Reservamo-nos o direito de limitar quantidades por pedido</li>
                    </ul>

                    <h2>4. Pedidos e Pagamentos</h2>
                    <p>
                        Ao realizar um pedido, você está fazendo uma oferta de compra. A Fracaro Store 
                        se reserva o direito de aceitar ou recusar pedidos. Aceitamos pagamentos via:
                    </p>
                    <ul>
                        <li>Cartão de crédito</li>
                        <li>PIX</li>
                        <li>Boleto bancário</li>
                    </ul>

                    <h2>5. Propriedade Intelectual</h2>
                    <p>
                        Todo o conteúdo do site (textos, imagens, logotipos, ilustrações, layout) é de 
                        propriedade da Fracaro Store e protegido pelas leis de propriedade intelectual. 
                        É proibida a reprodução sem autorização prévia.
                    </p>

                    <h2>6. Uso Adequado</h2>
                    <p>Ao utilizar nosso site, você se compromete a não:</p>
                    <ul>
                        <li>Utilizar o site para fins ilegais ou não autorizados</li>
                        <li>Transmitir vírus, malware ou qualquer código malicioso</li>
                        <li>Tentar acessar áreas restritas do sistema</li>
                        <li>Realizar ações que possam sobrecarregar nossos servidores</li>
                        <li>Utilizar robôs ou scripts automatizados para coletar dados</li>
                    </ul>

                    <h2>7. Limitação de Responsabilidade</h2>
                    <p>
                        A Fracaro Store não se responsabiliza por danos indiretos, incidentais ou 
                        consequentes decorrentes do uso do site. Nossa responsabilidade está limitada 
                        ao valor do produto adquirido.
                    </p>

                    <h2>8. Legislação Aplicável</h2>
                    <p>
                        Estes termos são regidos pelas leis brasileiras. Qualquer disputa será resolvida 
                        no foro da comarca de São Paulo, SP.
                    </p>

                    <div className='info-contato'>
                        <h3>Dúvidas sobre os termos?</h3>
                        <p>
                            Email: <a href="mailto:fracarostore@gmail.com">fracarostore@gmail.com</a><br />
                            WhatsApp: <a href="https://wa.me/5511997636154" target="_blank" rel="noopener noreferrer">(11) 99763-6154</a>
                        </p>
                    </div>

                    <p className='ultima-atualizacao'>Última atualização: Janeiro de 2026</p>
                </div>
            </main>
            <Rodape />
        </section>
    );
}
